import { gql } from '@apollo/client'
import { ITEM_FIELDS, ITEM_FULL_FIELDS } from './items'
import { COMMENTS_ITEM_EXT_FIELDS } from './comments'
import { DOMAIN_FULL_FIELDS } from './domains'
import { STREAK_FIELDS } from './streak-fields'

export const SUB_FIELDS = gql`
  fragment SubFields on Sub {
    name
    createdAt
    postTypes
    rankingType
    billingType
    billingCost
    billingAutoRenew
    billedLastAt
    billPaidUntil
    postsPiconerosFilter
    postPremiumPiconeros
    commentPremiumPiconeros
    userId
    desc
    status
    billingStatus
    meMuteSub
    meSubscription
    nsfw
  }`

export const SUB_FULL_FIELDS = gql`
  ${SUB_FIELDS}
  ${STREAK_FIELDS}
  fragment SubFullFields on Sub {
    ...SubFields
    lexicalState
    html
    user {
      name
      id
      ...StreakFields
    }
  }`

export const SUB_BRANDING_FIELDS = gql`
  fragment SubBrandingFields on SubBranding {
    subName
    primaryColor
    secondaryColor
    linkColor
    logoId
    title
    tagline
    faviconId
  }`

export const SUB = gql`
  ${SUB_FIELDS}

  query Sub($sub: String) {
    sub(name: $sub) {
      ...SubFields
    }
  }`

// territory edit with domain and branding forms
export const SUB_EDIT = gql`
  ${SUB_FIELDS}
  ${SUB_BRANDING_FIELDS}
  ${DOMAIN_FULL_FIELDS}
  query SubEdit($sub: String) {
    sub(name: $sub) {
      ...SubFields
      domain { ...DomainFullFields }
      branding { ...SubBrandingFields }
    }
  }`

export const SUB_FULL = gql`
  ${SUB_FULL_FIELDS}

  query Sub($sub: String) {
    sub(name: $sub) {
      ...SubFullFields
    }
  }`

export const SUBS = gql`
  ${SUB_FIELDS}
  query Subs($subNames: [String!]) {
    subs(subNames: $subNames) {
      ...SubFields
    }
  }`

export const ACTIVE_SUBS = gql`
  ${SUB_FIELDS}

  query ActiveSubs {
    activeSubs {
      ...SubFields
    }
  }`

export const SUB_ITEMS = gql`
  ${SUB_FULL_FIELDS}
  ${ITEM_FIELDS}
  ${COMMENTS_ITEM_EXT_FIELDS}

  query SubItems($sub: String, $sort: String, $cursor: String, $type: String, $name: String, $when: String, $from: String, $to: String, $by: String, $limit: Limit, $includeComments: Boolean = false) {
    sub(name: $sub) {
      ...SubFullFields
    }

    items(sub: $sub, sort: $sort, cursor: $cursor, type: $type, name: $name, when: $when, from: $from, to: $to, by: $by, limit: $limit) {
      cursor
      items {
        ...ItemFields
        ...CommentItemExtFields @include(if: $includeComments)
        position
      },
      pins {
        ...ItemFields
        ...CommentItemExtFields @include(if: $includeComments)
        position
      }
    }
  }
`

export const SUB_SEARCH = gql`
  ${SUB_FIELDS}
  ${ITEM_FULL_FIELDS}
  query SubSearch($sub: String, $q: String, $cursor: String, $sort: String, $what: String, $when: String, $from: String, $to: String) {
    sub(name: $sub) {
      ...SubFields
    }
    search(q: $q, cursor: $cursor, sort: $sort, what: $what, when: $when, from: $from, to: $to) {
      cursor
      searchSuggestion
      items {
        ...ItemFullFields
        searchTitle
        searchText
      }
    }
  }
`

export const SUB_SUGGESTIONS = gql`
  query subSuggestions($q: String!, $limit: Limit) {
    subSuggestions(q: $q, limit: $limit) {
      name
    }
  }
`

export const TOP_SUBS = gql`
  ${SUB_FULL_FIELDS}
  query TopSubs($cursor: String, $when: String, $from: String, $to: String, $by: String, ) {
    topSubs(cursor: $cursor, when: $when, from: $from, to: $to, by: $by) {
      subs {
        ...SubFullFields
        nitems(when: $when, from: $from, to: $to)

        optional {
          stacked(when: $when, from: $from, to: $to)
          spent(when: $when, from: $from, to: $to)
          revenue(when: $when, from: $from, to: $to)
        }
      }
      cursor
    }
  }
`

export const UPSERT_SUB_BRANDING = gql`
  ${SUB_BRANDING_FIELDS}
  mutation UpsertSubBranding($subName: String!, $branding: SubBrandingInput!) {
    upsertSubBranding(subName: $subName, branding: $branding) {
      name
      branding { ...SubBrandingFields }
    }
  }
`
